import React, { Component, PropTypes } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import CodeEditor from '@uiw/react-textarea-code-editor';//Leaving this one in because it's kinda neat
import RichTextEditor from 'react-rte';
import { Form, FormGroup, Button, Input, Badge, Modal, ModalBody, ModalHeader, ModalFooter, Label } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import moment from 'moment';
import { connect } from 'react-redux';

class NoReplyEmail extends Component {
    static displayName = NoReplyEmail.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            value: RichTextEditor.createEmptyValue(),
            addModal: false,
            addType: "",
            toList: [],
            ccList: [],
            bcList: [],
            subjectLine: "",
            saveModal: false,
            selectedEmail: "",
            createNewModal: false,
            newNameValue: "",
            emails: [],
            activeDeptPK: "",
            bodySaveSuccess: false,
            uploadFile: [],
            dropdownActive: "DEFAULT",
            attachStatus: true,
            attachList: [],
            testSuccess: false,
            sendSuccess: false
        }
        this.testPermission();
    }

    static propTypes = {//This is part of the rich-text editor handling
        onChange: PropTypes.func
    };

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } })
        //    .then((response) => response.json())
        //    .then((responseJSON) => { this.writeUserData(responseJSON) })//Another round of experimentation, this is forcing the recordComingHere() and testPermission() functions to execute after writeUserData()
        //    //.then((responseLog) => { this.recordComingHere() })//It doesn't work as well as I'd hoped, but it works.
        //    .then((responseState) => { this.testPermission() })
        //localStorage.setItem("lastFetch", moment());
        this.writeUserData(this.props.reduxData.userInfo)
    }

    writeUserData(input) {//Putting a this.setState() into a .then() isn't as well handled as you'd think. Thus, it goes here.
        this.setState({
            returnable: input
        })
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1037",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
        
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1037"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getUserDeptPK();
    }

    async getUserDeptPK() {//This is one of those pages that will change based on the department the user is active in. We're basing this on DeptPK as that's the name of the folder associated with that department
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('GetUserDeptPK', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            activeDeptPK: data.deptpk
        })
        this.getEmailList();
    }

    async getEmailList() {//At first, we only need the list of emails associated to the department. todo: pass department PK into here via parameters instead of relying on passing it through state?
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            department: this.state.activeDeptPK
        }
        const response = await fetch('GetAllEmails', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            emails: data
            })
    }

    componentDidMount() {

    }

    onChange = (value) => {
        this.setState({ value });
        if (this.props.onChange) {
            // Send the changes up to the parent component as an HTML string. This allows to save the rich-text into the database as HTML, to make converting to email format easier.
            this.props.onChange(
                value.toString('html')
            );
        }
    };

    openAdd(target) {//This modal is going to be defining which list (to, cc, or bcc) we're adding to. This is not async, as all we're doing is opening or closing a modal fully within client
        this.setState({
            addModal: true,
            addType: target
            })
    }

    async sendEmail(type) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.saveBody();//The users sometimes forget to save their email body before doing things like sending emails, so we'll make sure we do that for them just in case.
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            emailpk: this.state.selectedEmail,
            deptpk: this.state.activeDeptPK,
            sendtype: type
        }
        const response = await fetch('SendNoReplyEmail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (type == 'TEST') {//The other difference between TEST and SEND is where the success message appears. It should be next to the button they clicked.
            this.setState({
                testSuccess: data
            })
            setTimeout(() => {
                this.setState({
                    testSuccess: false
                })
            }, 6000)
        }
        if (type == 'PROD') {
            this.setState({
                sendSuccess: data
            })
            setTimeout(() => {
                this.setState({
                    sendSuccess: false
                    })
            }, 6000)
        }
    }

    toggleAddModal() {//This toggle is keyed to control for whether the modal is already open without parameters. If the modal is already open (which it should be in every case this function is called), it'll
                        //set the type to blank as it closes the modal so the next time it's opened it'll have a fresh field to define. If it's not already open, go ahead and open it.
        if (this.state.addModal == true) {
            this.setState({
                addModal: false,
                addType: ""
            })
        }
        else {
            this.setState({
                addModal: true
                })
        }
    }

    toggleSaveModal() {//This is a bit depreciated since the Save button doesn't need a modal anymore
        this.setState({
            saveModal: !this.state.saveModal
            })
    }

    saveEmail() {
        this.setState({
            saveModal: false
            })
    }

    toggleCreateModal() {//This will open the Create New modal
        this.setState({
            createNewModal: !this.state.createNewModal
            })
    }

    async createNew() {//The interesting thing about this is that when we create a new email, we also have to create the file structure on rigel to allow for this. That happens in the C#, though.
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            emailname: this.state.newNameValue,
            deptpk: this.state.activeDeptPK
            }
        const response = await fetch('CreateNewEmail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let processedTo = [];//Most of this is carried over as a relic of the normal getEmail process because the CreateNewEmail fetch is returning the same email data structure. This one doesn't need it,
                             //but because it's returning from the same procedure it needs to be able to handle it in the off chance it becomes necessary
        let processedCC = [];
        let processedBCC = [];
        if (data.tolist.length != 0) processedTo = data.tolist.split(';');
        if (data.cclist.length != 0) processedCC = data.cclist.split(';');
        if (data.bcclist.length != 0) processedBCC = data.bcclist.split(';');
        this.setState({
            toList: processedTo,
            ccList: processedCC,
            bcList: processedBCC,
            subjectLine: data.subjectline,
            selectedEmail: data.pk,
            dropdownActive: data.pk
        })
        this.toggleCreateModal();
        this.getEmailList();
    }

    async getEmail(pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpk: pk
        }
        const response = await fetch('GetEmail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let processedTo = [];//Here is where this is actually needed. The list of email addresses is saved as a single string with a semicolon between them. Here, we define a list for each one, and then take
                            //the string we retrieved from the database and pull it apart into the list based on the semicolon delimiter. This needs to only happen if there's data in this string because
                            //if there's not, the .split(';') fails.
        let processedCC = [];
        let processedBCC = [];
        if (data.tolist.length != 0) processedTo = data.tolist.split(';');
        if (data.cclist.length != 0) processedCC = data.cclist.split(';');
        if (data.bcclist.length != 0) processedBCC = data.bcclist.split(';');
        this.setState({
            toList: processedTo,
            ccList: processedCC,
            bcList: processedBCC,
            subjectLine: data.subjectline,
            selectedEmail: data.pk,
            value: RichTextEditor.createValueFromString(data.bodytext, "html"),
            dropdownActive: pk
        })
        this.getAttachments();
    }

    async addEmail(type, email) {//This one adds a new address to one of the three mailing types.
        this.saveBody();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpk: this.state.selectedEmail,
            type: type,
            address: email
        }
        const response = await fetch('AddEmailAddress', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let processedTo = [];
        let processedCC = [];
        let processedBCC = [];
        if (data.tolist.length != 0) processedTo = data.tolist.split(';');
        if (data.cclist.length != 0) processedCC = data.cclist.split(';');
        if (data.bcclist.length != 0) processedBCC = data.bcclist.split(';');
        this.setState({
            toList: processedTo,
            ccList: processedCC,
            bcList: processedBCC,
            subjectLine: data.subjectline,
            selectedEmail: data.pk,
            value: RichTextEditor.createValueFromString(data.bodytext, "html")
        })
    }

    async removeAddress(address, type) {//This removes an address from a specific type. 
        this.saveBody();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpk: this.state.selectedEmail,
            type: type,
            address: address
        }
        const response = await fetch('RemoveEmailAddress', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let processedTo = [];
        let processedCC = [];
        let processedBCC = [];
        if (data.tolist.length != 0) processedTo = data.tolist.split(';');
        if (data.cclist.length != 0) processedCC = data.cclist.split(';');
        if (data.bcclist.length != 0) processedBCC = data.bcclist.split(';');
        this.setState({
            toList: processedTo,
            ccList: processedCC,
            bcList: processedBCC,
            subjectLine: data.subjectline,
            selectedEmail: data.pk,
            value: RichTextEditor.createValueFromString(data.bodytext, "html")
        })
    }

    async saveSubject() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.saveBody();//We put this in front of the majority of our functions in this component because as said earlier, users tend to forget to mash the save button. We need to do it for them.
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            subjectline: this.state.subjectLine,
            targetpk: this.state.selectedEmail
        }
        const response = await fetch('UpdateSubjectLine', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
    }

    async saveBody() {//Here the rich-text field data is actually saved to database. This doesn't happen onBlur because for some reason the npm package I'm using really doesn't want to use onBlur
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            target: this.state.selectedEmail,
            body: this.state.value.toString("html")
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('UpdateEmailBody', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            bodySaveSuccess: data
        })
        setTimeout(() => {
            this.setState({
                bodySaveSuccess: false
            })
        }, 6000)
    }

    handleFileChange (e)  {//This handles selecting a file to be added
        if (e.target.files) {
            this.setState({
                uploadFile: e.target.files[0]
                })
        }
    }

    async uploadButton() {//This one handles uploading a file to the email's file in rigel. It doesn't actually hit Altair at all.
        this.saveBody();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (this.state.uploadFile.type == "application/pdf") {
            const formData = new FormData();
            formData.append("userLevel", this.props.reduxData.userInfo.level.pk);
            formData.append("targetfile", this.state.uploadFile);
            formData.append("targetname", this.state.uploadFile.name);
            formData.append("deptpk", this.state.activeDeptPK);
            formData.append("emailpk", this.state.selectedEmail);
            const res = await axios.post("AttachmentUpload", formData, {
                headers: { 'Authorization': bearerVAR }
            });
            if (res.data == false) {
                alert("Your attachment could not be added. This is likely due to the file having the same name as an existing attachment.")
            }
        }
        else alert("You may only upload .pdf files to UnderTheHood")
        this.getAttachments();
        //localStorage.setItem("lastFetch", moment());
    }

    async getAttachments() {//This fetch also doesn't hit Altair, all it needs to do is find all the files for this email
        let toSend = {
            deptpk: this.state.activeDeptPK,
            emailpk: this.state.selectedEmail
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('GetAttachmentList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',  'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            attachList: data
            })
    }

    async removeAttachment(filename) {//This deletes a file from this email's folder structure
        this.saveBody();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            filename: filename,
            emailpk: this.state.selectedEmail,
            deptpk: this.state.activeDeptPK,
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('RemoveAttachment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.getAttachments();
    }

    emailEditor() {
        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed). We are removing images and a few other types of controls that don't work very well.
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', /*'IMAGE_BUTTON',*/ 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],//One day images may be viable
            INLINE_STYLE_BUTTONS: [
                { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
                { label: 'Italic', style: 'ITALIC' },
                { label: 'Strikethrough', style: 'STRIKETHROUGH' },
                { label: 'Monospace', style: 'CODE' },
                { label: 'Underline', style: 'UNDERLINE' }
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: 'Normal', style: 'unstyled' },
                { label: 'Heading Large', style: 'header-one' },
                { label: 'Heading Medium', style: 'header-two' },
                { label: 'Heading Small', style: 'header-three' },
                { label: 'Code Block', style: 'code-block' }
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: 'UL', style: 'unordered-list-item' },
                { label: 'OL', style: 'ordered-list-item' }
            ]
        };
        return (
            <div>
                <Modal isOpen={this.state.addModal} toggle={this.toggleAddModal.bind(this)}>
                    <ModalHeader toggle={this.toggleAddModal.bind(this)}>Add...</ModalHeader>
                    <ModalBody>
                        <Input type="email" name="addemail" id="addemail" onBlur={(e) => this.addEmail(this.state.addType, e.target.value)} />
                    </ModalBody>
                    <ModalFooter><Button onClick={this.toggleAddModal.bind(this)}>Close</Button></ModalFooter>
                </Modal>
                <Modal isOpen={this.state.saveModal} toggle={this.toggleSaveModal.bind(this)} >
                    <ModalHeader toggle={this.toggleSaveModal.bind(this)}>Save</ModalHeader>
                    <ModalBody>text go here</ModalBody>
                    <ModalFooter><Button onClick={this.saveEmail.bind(this)}>Save</Button></ModalFooter>
                </Modal>
                <Button size="sm" outline onClick={() => this.openAdd("to")}>+</Button>&emsp;<strong>To: </strong>
                {this.state.toList.map(item => (<div className="inlineCustom"><Badge>{item} <Button close size="sm" onClick={() => this.removeAddress(item, "to") }></Button></Badge>&nbsp;</div>))}
                <br />
                <Button size="sm" outline onClick={() => this.openAdd("cc")}>+</Button>&emsp;<strong>CC: </strong>
                {this.state.ccList.map(item => (<div className="inlineCustom"><Badge>{item}  <Button close size="sm" onClick={() => this.removeAddress(item, "cc")}></Button></Badge>&nbsp;</div>))}
                <br />
                <Button size="sm" outline onClick={() => this.openAdd("bc")}>+</Button>&emsp;<strong>Bcc: </strong>
                {this.state.bcList.map(item => (<div className="inlineCustom"><Badge>{item}  <Button close size="sm" onClick={() => this.removeAddress(item, "bc")}></Button></Badge>&nbsp;</div>))}
                <br />
                <br />
                <strong>Attachments</strong>
                <FormGroup className="inlineCustom d-flex"><Input type="file" onChange={(e) => this.handleFileChange(e)} /><Button className="inlineCustom" onClick={() => this.uploadButton()} >Add</Button></FormGroup>
                {this.state.attachList.map(item => (
                    <div className="inlineCustom"><Badge>{item} <Button close onClick={() => this.removeAttachment(item)} /></Badge>&nbsp;</div>
                    )) }
                <p />
                <strong>Subject</strong>&emsp;<Input type="text" name="subject" id="subject" value={this.state.subjectLine} onChange={(e) => this.setState({ subjectLine: e.target.value })} onBlur={this.saveSubject.bind(this)} />
                <br />
                <strong>Body</strong>
                <RichTextEditor
                    value={this.state.value}
                    onChange={this.onChange}
                    toolbarConfig={toolbarConfig}
                    blur={this.saveBody.bind(this)}
                />
                <br />
                <Button onClick={this.saveBody.bind(this)}>Save</Button>&nbsp;{this.state.bodySaveSuccess && <GoCheck />}
                <br />
                <br />
                <div className="rightAlignCustom"><Button onClick={() => this.sendEmail("TEST")}>Test</Button>&nbsp;{this.state.testSuccess && <div className="inlineCustom">Success <GoCheck /></div>} &emsp;&emsp;<Button color="primary" onClick={() => this.sendEmail("PROD")}>Send</Button>&nbsp;{this.state.sendSuccess && <div className="inlineCustom">Success <GoCheck /></div>}</div>
                <br />
                <br />
            </div>
            );
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let displayEmail = <div></div>
        if (this.state.selectedEmail != "") displayEmail = this.emailEditor();
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Modal isOpen={this.state.createNewModal} toggle={this.toggleCreateModal.bind(this)}>
                                <ModalHeader toggle={this.toggleCreateModal.bind(this)}>Create New</ModalHeader>
                                <ModalBody>
                                    <Form>
                                        <FormGroup>
                                            <Label>Name</Label>
                                            <Input type="text" name="emailname" id="emailname" value={this.state.newNameValue} onChange={(e) => this.setState({ newNameValue: e.target.value })} />
                                        </FormGroup>
                                    </Form>
                                </ModalBody>
                                <ModalFooter><Button onClick={this.createNew.bind(this)}>Create</Button> </ModalFooter>
                             </Modal>
                            <Form inline className="d-flex">
                                <FormGroup>
                                    <Input type="select" name="chooseEmail" id="chooseEmail" value={this.state.dropdownActive} onChange={(e) => this.getEmail(e.target.value)}>
                                        <option disabled value="DEFAULT" selected>Select Email...</option>
                                        {this.state.emails.map(item => (
                                            <option value={item.pk}>{item.emailname}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Button onClick={this.toggleCreateModal.bind(this)}>New Email</Button>
                                </FormGroup>
                            </Form>
                            <br />
                            {displayEmail}
                        </div>
                    )}
                </UserContext.Consumer>
            );
        }
    
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(NoReplyEmail);